import type {
  IndustrialPremisesTerms,
  ParkingSpotTerms,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const MarketTermsItem: RelationFieldProps<
  IndustrialPremisesTerms | ParkingSpotTerms
> = {
  filters: [],
  renderItem: (item) => ({
    title: item.name,
    descriptionItems: <></>,
  }),
};
